<template lang="pug">
	.creative--publish-creative()
		FileUploader(ref="uploader", :uploadText="$tCaption('Publish')" @file-selected="fileSelected = true", :dropZoneHeight="480", :closeOnOutsideClick="false", :popupConfig="{ height: 580 }", :isUIHidden="true",
			@upload="onCommitFile", :dropText="$tCaption('Drop excel file with free text values or skip')")
			template(slot="actions-right")
				DxButton(:type="fileSelected ? 'normal' : 'success'", :text="$tCaption('Skip and publish')", @click="skip")
</template>

<script>
	import FileUploader from 'app-core/FileUploader.vue';
	import DxButton from 'devextreme-vue/button';
	import axios from 'axios';

	export default {
		translationCategory: 'creative.Detail',
		name: 'creative--publish-creative',
		components: {
			FileUploader, DxButton
		},
		props: ['creative', 'publicationStatistic'],
		data() {
			return {
				fileSelected: false,
				innerCreative: this.creative,
			};
		},
		computed: {
			publicationStatisticData: {
				get() {
					return this.publicationStatistic;
				},
				set(v) {
					this.$emit('update:publicationStatistic', v);
				}
			},
		},
		watch: {
			creative(v) {
				this.innerCreative = v;
			}
		},
		methods: {
			publish(creative) {
				if (creative) {
					this.innerCreative = creative;
				}
				setImmediate(() => {
					if (this.innerCreative?.HasFreeText) {
						this.fileSelected = false;
						this.$refs.uploader?.showPopup();
					} else {
						if (this.publicationStatisticData?.LastSession && this.publicationStatisticData?.LastSession?.Status > 1) {
							this.$confirmMessage({
								title: this.$tCaption('Confirm action', '@actions'),
								text: this.$tCaption('Are you sure you want to create a new publication? An unfishied publication was found, would you like to re-try?'),
								buttons: [{
									text: this.$tCaption('Retry'),
									type: 'success',
									onClick: () => this.publishFinalAudioServerside(this.publicationStatisticData?.LastSession?.SessionId)
								}, {
									type: 'default',
									text: this.$tCaption('New publish'),
									onClick: () => this.publishFinalAudioServerside()
								}, {
									type: 'normal',
									text: this.$tCaption('Cancel', '@actions')
								}]
							});
						} else {
							this.$confirmMessage({
								title: this.$tCaption('Confirm action', '@actions'),
								text: this.$tCaption('Are you sure you want to start publication of the current creative?'),
								handler: () => {
									this.publishFinalAudioServerside();
								}
							});
						}
					}
				});
			},
			skip() {
				this.$refs.uploader?.close();
				this.publishFinalAudioServerside();
			},
			onCommitFile(filesBlob) {
				const file = filesBlob[0];
				this.publishFinalAudioServerside(void 0, file);
			},
			publishFinalAudioServerside(retryPublicationSessionId, file) {
				if (__DEBUG__)
					console.debug('Publish final audio serverside', { retryPublicationSessionId, file });
				if (this.innerCreative.isPublished) return;
				this.$emit('publish', retryPublicationSessionId, file, this.innerCreative);
				if (this.publicationStatisticData)
					this.publicationStatisticData.InProgress++;
				this.$eventsBus.$emit('notification-message', {
					message: this.$tCaption('Starting publishing audio for creative (CREATIVE_NAME).').replace('CREATIVE_NAME', this.innerCreative?.Name),
					icon: 'arrow-right',
					type: 'info'
				});
				this.$eventsBus.$emit('notification-busy', true);

				const data = new FormData();
				data.append('creativeId', this.innerCreative?.Oid);
				if (retryPublicationSessionId)
					data.append('publicationSessionId', retryPublicationSessionId);
				if (file)
					data.append('excelFile', file);

				this.publicationStatisticData = { InProgress: 1, LastSession: { Status: 0 } };
				return axios.post(this.$Data.getMethodUrl('postExternalApi?method=creative/PublishCreative'), data, {
					headers: {
						'Content-Type': 'multipart/form-data',
						authToken: this.$auth.accessToken(),
						...__HEADERS__
					}
				}).then(r => {
					if (__DEBUG__)
						console.debug('Publication result', { r });
					if (r?.data?.ErrorMessage) {
						this.$notifyMessage(r?.data?.ErrorMessage, { icon: 'times', type: 'error' });
					}
				}).finally(() => {
					this.$eventsBus?.$emit('notification-busy', false);
					if (this._isDestroyed) return;
					this.$emit('publish-initialized', this.innerCreative);
				});
			},
		}
	};
</script>
<style lang='scss'>
	.creative--publish-creative {
	}
</style>
